import { DatenauswertungGenerisch } from '../datenauswertung/DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { formatNumber } from '../../core/formatter/formatNumber';
import { getStyle } from '../datenauswertung/generisch/DatanauswertungGenerischStyles';
import { getValuesKWH } from '../datenauswertung/energietraeger/getValuesKWH';
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';
import * as React from 'react';

interface ZusatzToolsZertifizierungTabelle1Props extends React.ClassAttributes<any> {
    data: any;
}

interface ZusatzToolsZertifizierungTabelle1State {
    pdfString?: string;
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    alleJahre: boolean;
    renderButton: JSX.Element;
}

export class ZusatzToolsZertifizierungTabelle1 extends
    React.Component<ZusatzToolsZertifizierungTabelle1Props, ZusatzToolsZertifizierungTabelle1State> {

    constructor(props: any) {
        super(props);
        const konfig: any[] = props.data[IDs.ENT_KONFIGURATION] || [];
        const jahrMax = Moment().year() - 1;
        let jahrMin = 2010;

        if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
            jahrMin = konfig[0].startjahr_datenerfassung;
        }
        this.state = {
            jahr: jahrMax,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            alleJahre: false,
            renderButton: undefined
        };
    }

    getValues(): any {
        const data: any = this.props.data || {};
        const diag1: any[] = [];
        const diag2: any[] = [];
        const energietraeger: any[] = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
        const kennzahlen: any[] = data[IDs.KENNZIFFERN_BERECHNET] || [];
        const rows: any[] = [];
        const alleJahre = this.state.alleJahre;
        const jahrSel = this.state.jahr;

        for (let jahr = this.state.jahrMin; jahr <= this.state.jahrMax; jahr++) {
            // console.log('Jahr: ', jahr, jahrSel);
            if (jahrSel !== jahr && !alleJahre) {
                continue;
            }
            // Strom
            if (kennzahlen[jahr]) {
                const verbrauch_gesamt = kennzahlen[jahr]['gesamtverbrauch'];
                const kosten_gesamt = kennzahlen[jahr]['kosten_total'];

                if (kennzahlen[jahr]['strom_kosten_gesamt']) {
                    const verbrauch_strom = kennzahlen[jahr]['strom_verbrauch_gesamt'];
                    const anteil_verbrauch_strom = (100 / verbrauch_gesamt) * verbrauch_strom;
                    const kosten_strom = kennzahlen[jahr]['strom_kosten_gesamt'];
                    const anteil_kosten_strom = (100 / kosten_gesamt) * kosten_strom;
                    const row = [
                        jahr, 'Strom',
                        formatNumber(verbrauch_strom, 0),
                        `${formatNumber(anteil_verbrauch_strom, 0)}%`,
                        formatNumber(kosten_strom, 0),
                        `${formatNumber(anteil_kosten_strom, 0)}%`,
                        kennzahlen[jahr]['strom_messsystem'], kennzahlen[jahr]['strom_kalibrierung']
                    ];
                    rows.push(row);
                }
                /*
                if (kennzahlen[jahr]['kosten_waerme']) {
                    const verbrauch_waerme = kennzahlen[jahr]['verbrauch_waerme_kwh'];
                    const anteil_verbrauch_waerme = (100 / verbrauch_gesamt) * verbrauch_waerme;
                    const kosten_waerme = kennzahlen[jahr]['kosten_waerme'];
                    const anteil_kosten_waerme = (100 / kosten_gesamt) * kosten_waerme;
                    const row = [
                        jahr, 'Wärme',
                        formatNumber(verbrauch_waerme, 0),
                        `${formatNumber(anteil_verbrauch_waerme, 0)}%`,
                        formatNumber(kosten_waerme, 0),
                        `${formatNumber(anteil_kosten_waerme, 0)}%`, '', ''
                    ];
                    rows.push(row);
                }
                */
                const arr_kraftstoffe = [
                    {
                        name: 'Benzin', verbrauch: 'benzin_kwh', kosten: 'benzin_kosten', messsystem: 'benzin_messsystem',
                        kalibrierung: 'benzin_kalibrierung'
                    },
                    {
                        name: 'Diesel', verbrauch: 'diesel_kwh', kosten: 'diesel_kosten', messsystem: 'diesel_messsystem',
                        kalibrierung: 'diesel_kalibrierung'
                    },
                    {
                        name: 'LPG', verbrauch: 'lpg_kwh', kosten: 'lpg_kosten', messsystem: 'lpg_messsystem',
                        kalibrierung: 'lpg_kalibrierung'
                    },
                    {
                        name: 'Wasserstoff', verbrauch: 'wasserstoff_kwh', kosten: 'wasserstoff_kosten',
                        messsystem: 'wasserstoff_messsystem', kalibrierung: 'wasserstoff_kalibrierung'
                    },
                    {
                        name: 'Ladestrom', verbrauch: 'ladestrom_kwh', kosten: 'ladestrom_kosten', messsystem: 'ladestrom_messsystem',
                        kalibrierung: 'ladestrom_kalibrierung'
                    },
                    {
                        name: 'Erdgas (Kraftstoff)', verbrauch: 'erdgas_kraftstoff_kwh', kosten: 'erdgas_kraftstoff_kosten',
                        messsystem: 'erdgas_messsystem', kalibrierung: 'erdgas_kalibrierung'
                    }
                ];
                /*
                if (kennzahlen[jahr]['kraftstoffe_kosten']) {
                    const verbrauch_kraftstoffe = kennzahlen[jahr]['kraftstoff_kwh'];
                    const anteil_verbrauch_kraftstoffe = (100 / verbrauch_gesamt) * verbrauch_kraftstoffe;
                    const kosten_kraftstoffe = kennzahlen[jahr]['kraftstoffe_kosten'];
                    const anteil_kosten_kraftstoffe = (100 / kosten_gesamt) * kosten_kraftstoffe;
                    const row = [
                        jahr, 'Kraftstoffe',
                        formatNumber(verbrauch_kraftstoffe, 0),
                        `${formatNumber(anteil_verbrauch_kraftstoffe, 0)}%`,
                        formatNumber(kosten_kraftstoffe, 0),
                        `${formatNumber(anteil_kosten_kraftstoffe, 0)}%`, '', ''
                    ];
                    rows.push(row);
                }
                */
                arr_kraftstoffe.forEach((item: any) => {
                    if (kennzahlen[jahr][item.kosten]) {
                        const verbrauch_kraftstoffe = kennzahlen[jahr][item.verbrauch];
                        const anteil_verbrauch_kraftstoffe = (100 / verbrauch_gesamt) * verbrauch_kraftstoffe;
                        const kosten_kraftstoffe = kennzahlen[jahr][item.kosten];
                        const anteil_kosten_kraftstoffe = (100 / kosten_gesamt) * kosten_kraftstoffe;
                        const row = [
                            jahr, item.name,
                            formatNumber(verbrauch_kraftstoffe, 0),
                            `${formatNumber(anteil_verbrauch_kraftstoffe, 0)}%`,
                            formatNumber(kosten_kraftstoffe, 0),
                            `${formatNumber(anteil_kosten_kraftstoffe, 0)}%`,
                            kennzahlen[jahr][item.messsystem], kennzahlen[jahr][item.kalibrierung]
                        ];
                        rows.push(row);
                    }
                });

                energietraeger.forEach((item: any) => {
                    const values_energietraeger = getValuesKWH(kennzahlen, this.props.data, jahr, item.id);

                    if (values_energietraeger.verbrauch_kwh > 0) {
                        const verbrauch_et = values_energietraeger.verbrauch_kwh;
                        const anteil_verbrauch_et = (100 / verbrauch_gesamt) * verbrauch_et;
                        const kosten_et = values_energietraeger.kosten;
                        const anteil_kosten_et = (100 / kosten_gesamt) * kosten_et;
                        const row = [
                            jahr, item.name,
                            formatNumber(verbrauch_et, 0),
                            `${formatNumber(anteil_verbrauch_et, 0)}%`,
                            formatNumber(kosten_et, 0),
                            `${formatNumber(anteil_kosten_et, 0)}%`,
                            values_energietraeger.messsystem, values_energietraeger.kalibrierung
                        ];
                        rows.push(row);
                    }
                });
            }
        }
        return { rows, diag1, diag2 };
    }

    render(): JSX.Element {
        const lineColor = ['#4f81bd', '#f79646', '#87bd51', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'];
        const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        const numCols = 8;
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const values = this.getValues();
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const config: any = {
            titel0: unternehmen,
            titel1: 'Nachweis Alternatives System',
            titel3: 'Tabelle 1 - Erfassung und Analyse eingesetzter Energieträger',
            filename: 'Alternatives_System_Energietraeger.pdf',
            baseWidth: baseWidth,
            header: {
                blocks: [
                    {
                        label: 'Jahr',
                        width: `${baseWidth}%`
                    },
                    {
                        label: ['Eingesetzte Energie', 'Eingesetzte\nEnergie'],
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'Energieträger' }
                        ]
                    },
                    {
                        label: 'Verbrauch',
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'kWh/Jahr' }
                        ]
                    },
                    {
                        label: ['Anteil am Gesamt-\nenergienverbrauch', 'Anteil am Gesamtenergie-\nverbrauch'],
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'Prozent' }
                        ]
                    },
                    {
                        label: 'Kosten',
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'Euro' }
                        ]
                    },
                    {
                        label: ['Kostenanteil\n(an den Energiekosten)', 'Kostenanteil\n(an den\nEnergiekosten)'],
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: 'Prozent' }
                        ]
                    },
                    {
                        label: 'Messsystem',
                        width: `${baseWidth}%`
                    },
                    {
                        label: 'Genauigkeit /\nKalibrierung',
                        width: `${baseWidth}%`
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header'],
            diagrams: []
        };

        return (
            <>
                <div
                    style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#eee', paddingLeft: 25, position: 'sticky', top: 0 }}
                >
                    {this.renderJahresauswahl()}
                </div>
                <div style={{ margin: 10 }}>
                    <div style={{ fontSize: '10pt', paddingLeft: 20 }}>
                        <b>Hinweis:</b> Diese Daten wurden automatisch aus der Dateneingabe generiert.
                    </div>
                    <DatenauswertungGenerisch
                        config={config}
                        orientation='portrait'
                        setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    />
                </div>
            </>
        );
    }

    renderAlleJahreCheckbox(): JSX.Element {
        return (
            <div style={{ display: 'flex', height: '100%', flexDirection: 'row', alignItems: 'center', fontStyle: 'italic', color: '#888', margin: 'auto auto auto 5px' }}>
                <input
                    style={{ margin: 'auto 5px' }}
                    type='checkbox'
                    checked={this.state.alleJahre}
                    onChange={(evt: any) => this.setState({ alleJahre: evt.target.checked })}
                />
                Alle Jahre anzeigen
            </div>
        );
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <div style={{ width: '100%', maxWidth: 1367, boxSizing: 'border-box' }}>
                <DatenauswertungJahrauswahlEinzeln
                    jahrMax={this.state.jahrMax}
                    jahrMin={this.state.jahrMin}
                    jahr={this.state.jahr}
                    externalHeaderElements={[this.renderAlleJahreCheckbox(), this.state.renderButton]}
                    disabled={this.state.alleJahre}
                    onJahrChange={(jahr: number) => this.setState({ jahr: +jahr })}
                />
            </div>
        );
    }
}
